export async function previewLoader({ params }) {
  if (params.photoPaths) {
    return params.photoPaths;
  }
  return null;
}
